
import React from "react";

import TailoredSolutionsContent from "./TailoredSolutionsContent";

import * as S from "./styles";
import { HOMEPAGE_ANCHOR_CONTAINER_IDs } from "../../../lib/constants";

export function TailoredSolutionsSection() {
  return (
    <S.StyledSection id={HOMEPAGE_ANCHOR_CONTAINER_IDs.useCases.key}>
      {/* The heading is now managed inside the TailoredSolutionsContent component */}
      <TailoredSolutionsContent />
    </S.StyledSection>
  );
}
